import { GetBrokerPatientsTemplate, ImportBrokerPatients } from '@/api/endpoints/Broker/BrokerPatient'
import { usePost } from '@/api/hooks'
import { CRIcon } from '@/components/crRender'
import { FileUploadPopup } from '@/components/Exporter'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './style.css'
const UploadSheetPopup = ({ refModal }) => {

    const { onPost, isLoading } = usePost(ImportBrokerPatients)

    const { t } = useTranslation()

    const [isTemplateLoading, setIsTemplateLoading] = useState(false)

    const handleUpload = (files, handleClose) => {

        if (!files) return

        const formData = new FormData()
        files.forEach(file => {
            formData.append('file', file)
        })

        onPost(formData, () => { handleClose(); onClose() })
    }

    const onClose = () => refModal.current.click()


    const downloadTemplate = () => {
        setIsTemplateLoading(true)
        GetBrokerPatientsTemplate().then(_ => { }).finally(() => setIsTemplateLoading(false))
    }

    return (

        <FileUploadPopup
            large={false}
            multiple
            isLoading={isLoading}
            hintSection={
                <div className="download-template-container">
                    <div>  {t('file-hint')}</div>
                    <div onClick={downloadTemplate} className="download-template-btn">
                        {t('download-template')} <CRIcon isRender={isTemplateLoading} icon="eos-icons:loading" />
                    </div>
                </div>
            }
            name="upload-sheet"
            title="upload-sheet"
            maxFiles={100}
            maxFileSize={10 * 1024 * 1024}
            modalID={refModal}
            onUpload={handleUpload}
            onClose={onClose}
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
    )
}

export default UploadSheetPopup